// frontend/src/components/LogoutButton.js
import React, { useContext } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function LogoutButton() {
  const { setUserInfo } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
      setUserInfo(null);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="logout-button-container">
      <Button
        style={{ border: "1px solid #404040" }}
        className="logout-button"
        onClick={handleLogout}
        color="inherit"
      >
        Logout
      </Button>
    </div>
  );
}

export default LogoutButton;
